// Piezas visuales locales de Políticas (badges, rótulos, clases de campos). Si otra pantalla del
// dominio las repite, suben a domains/credit/components; a shared solo con ≥2 dominios.
import { cn } from '@/lib/cn';
import {
    POLICY_STATUS_BADGE_CLASS,
    POLICY_STATUS_LABEL,
    POLICY_TYPE_LABEL,
    type PolicyStatus,
    type PolicyType,
} from '../types';

const BADGE =
    'inline-flex items-center gap-1 rounded-[3px] px-1.5 py-px text-[9.5px] font-bold uppercase tracking-wide';

/** Label de campo del mock (`.form-field label`). */
export const FIELD_LABEL =
    'mb-1 block text-[10px] font-bold uppercase tracking-wide text-muted-foreground';
/** Input/textarea/select de formulario del mock (`.form-field input`). */
export const FIELD_INPUT =
    'w-full rounded-[5px] border border-border bg-background px-2 py-1.5 text-xs text-foreground outline-none focus:border-ring focus:ring-2 focus:ring-ring/15 disabled:opacity-50';

export function SecTitle({ children }: { children: React.ReactNode }) {
    return (
        <div className="mb-2 text-[10.5px] font-bold uppercase tracking-wider text-muted-foreground">
            {children}
        </div>
    );
}

export function TypeBadge({ type }: { type: PolicyType }) {
    return (
        <span className={cn(BADGE, 'border border-border bg-muted/70 text-foreground')}>
            {POLICY_TYPE_LABEL[type]}
        </span>
    );
}

export function StatusBadge({ status }: { status: PolicyStatus }) {
    return (
        <span className={cn(BADGE, POLICY_STATUS_BADGE_CLASS[status])}>
            {POLICY_STATUS_LABEL[status]}
        </span>
    );
}

/** Chip de evento del historial (`.evento-chip`). */
export function EventTag({ kind }: { kind: 'plan' | 'store_policy' }) {
    return (
        <span
            className={cn(
                BADGE,
                kind === 'plan'
                    ? 'bg-success/10 text-success'
                    : 'bg-destructive/10 text-destructive',
            )}
        >
            {kind === 'plan' ? 'Plan' : 'Tienda'}
        </span>
    );
}

/** Botón × para descartar cambios (`.btn-x-discard`). */
export function DiscardX({
    onClick,
    title = 'Descartar cambios',
}: {
    onClick: () => void;
    title?: string;
}) {
    return (
        <button
            type="button"
            onClick={onClick}
            title={title}
            aria-label={title}
            className="flex size-[26px] items-center justify-center rounded-[5px] border border-border text-[15px] leading-none text-muted-foreground transition-colors hover:border-destructive/40 hover:bg-destructive/10 hover:text-destructive"
        >
            ×
        </button>
    );
}
